import { pushCollectIncident } from '/fp/collect-incidents.js';

/**
 * When false, calling navigator.getGamepads() throws SecurityError (Permissions-Policy / iframe).
 * If the API is missing, return true and rely on try/catch around the call.
 * @returns {boolean}
 */
function permissionsPolicyAllowsGamepad() {
  try {
    if (typeof document === 'undefined') return true;
    const pp = document.permissionsPolicy;
    if (pp && typeof pp.allowsFeature === 'function') return pp.allowsFeature('gamepad');
    const fp = document.featurePolicy;
    if (fp && typeof fp.allowsFeature === 'function') return fp.allowsFeature('gamepad');
    return true;
  } catch (e) {
    return true;
  }
}

export default async function getNavigatorData() {
  let obj = {
    properties: {},
    functions: [],
    statuses: {},
    incidents: [],
  };

  const nav = window.navigator;

  // PluginArray / MimeTypeArray contain Plugin↔MimeType circular refs; full data lives in browser.plugins / browser.mimeTypes.
  const lengthOnlyProps = new Set(['plugins', 'mimeTypes']);

  for (var prop in nav) {
    try {
      if (lengthOnlyProps.has(prop)) {
        const collection = nav[prop];
        obj.properties[prop] = collection ? collection.length : null;
        continue;
      }
      obj.properties[prop] = nav[prop];
    } catch (e) {
      pushCollectIncident(obj.incidents, { source: 'navigator', phase: 'enumerateProperties', key: prop, error: e });
    }
  }

  obj.functions = getMethods(nav, obj.incidents);

  try {
    if (typeof nav.getGamepads !== 'function') {
      obj.statuses.gamepads = null;
    } else if (!permissionsPolicyAllowsGamepad()) {
      obj.statuses.gamepads = null;
    } else {
      obj.statuses.gamepads = nav.getGamepads();
    }
  } catch (e) {
    pushCollectIncident(obj.incidents, { source: 'navigator', phase: 'getGamepads', error: e });
    obj.statuses.gamepads = null;
  }

  try {
    obj.statuses.javaEnabled = nav.javaEnabled();
  } catch (e) {
    pushCollectIncident(obj.incidents, { source: 'navigator', phase: 'javaEnabled', error: e });
    obj.statuses.javaEnabled = false;
  }

  return obj;
}

const getMethods = (obj, incidents) => {
  let properties = new Set();
  let currentObj = obj;
  currentObj = Object.getPrototypeOf(currentObj);
  Object.getOwnPropertyNames(currentObj).map((item) => properties.add(item));
  return [...properties.keys()].filter((item) => {
    try {
      return typeof obj[item] === 'function';
    } catch (e) {
      pushCollectIncident(incidents, { source: 'navigator', phase: 'getMethods', key: item, error: e });
      return false;
    }
  });
};
